import {
  ArrowBack,
  ArrowBackIos,
  ArrowForwardIos,
  ArrowLeft,
  ArrowRight,
  Check,
  Close as CloseIcon,
  ExpandMore,
  SearchOutlined
} from '@mui/icons-material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Step,
  StepConnector,
  stepConnectorClasses,
  StepIconProps,
  StepLabel,
  Stepper,
  styled,
  TextField,
  Typography
} from '@mui/material'
import { ExplanationAccordion, LabelField } from 'components'
import * as controllers from 'controllers'
import { VehicleDto } from 'dtos'
import { PulledClusterPhotoDto } from 'dtos/pulledClusterPhotoDto'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import PulledClusterPhotoAddEditDialog from './PulledClusterPhotoAddEditDialog'
import { enqueueSnackbar } from 'notistack'
import NeedsClusterRemovedHeroCard from 'pages/todolist/NeedsClusterRemovedHeroCard'
import { VehicleNeedsClusterRemovedDetailsDto } from 'dtos/vehicleNeedsClusterRemovedDetailsDto'
import { useLayout } from 'context'
import Step1VehicleDetails from 'pages/vehicles/id/checkIn/Step1VehicleDetails'
import NeedsClusterRemovedScanClusterBarcodeCard from 'pages/todolist/NeedsClusterRemovedScanClusterBarcodeCard'
import NeedsClusterRemovedPulledClusterPhotoCard from 'pages/todolist/NeedsClusterRemovedPulledClusterPhotoCard'

interface NeedsClusterRemovedScanClusterBarcodeIndexProps {
  vehicle: VehicleDto
}

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)'
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#26b6ff'
    }
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#26b6ff'
    }
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1
  }
}))

const QontoStepIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: '#26b6ff'
  }),
  '& .QontoStepIcon-completedIcon': {
    color: '#26b6ff',
    zIndex: 1,
    fontSize: 18
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor'
  }
}))

function QontoStepIcon(props: StepIconProps) {
  const { active, completed, className } = props

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? <Check className='QontoStepIcon-completedIcon' /> : <div className='QontoStepIcon-circle' />}
    </QontoStepIconRoot>
  )
}

const steps = ['Scan Cluster Barcode', 'Pulled Cluster Photo', 'Pulled Cluster Review']

export default function NeedsClusterRemovedScanClusterBarcodeIndex({
  vehicle
}: NeedsClusterRemovedScanClusterBarcodeIndexProps) {
  const { vehicleGuid } = useParams()
  const layout = useLayout()
  const navigate = useNavigate()

  const [vehicleDetails, setVehicleDetails] = useState<VehicleDto | null>(null)
  const [isGettingVehicle, setIsGettingVehicle] = useState<boolean>(false)

  const [pulledClusterPhotoAddEditDialogOpen, setPulledClusterPhotoAddEditDialogOpen] = useState<boolean>(false)
  const [pulledClusterPhotoInformation, setPulledClusterPhotoInformation] = useState<PulledClusterPhotoDto>(
    new PulledClusterPhotoDto()
  )
  const [viewDetailsDialogOpen, setViewDetailsDialogOpen] = useState<boolean>(false)
  const [isGettingPulledClusterPhotoInformation, setIsGettingPulledClusterPhotoInformation] = useState<boolean>(false)
  const [isSavingPulledClusterPhotoInformation, setIsSavingPulledClusterPhotoInformation] = useState<boolean>(false)

  const [initialValues, setInitialValues] = useState<VehicleNeedsClusterRemovedDetailsDto>(
    new VehicleNeedsClusterRemovedDetailsDto()
  )

  const [parameters, setParameters] = useState({
    page: 0,
    pageSize: 10,
    search: '',
    VIN: undefined,
    openOnly: true
  })

  const { id } = useParams()

  const [activeStep, setActiveStep] = useState(0)

  const onNext = () => {
    setActiveStep(prev => Math.min(3, prev + 1))
  }

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1)
  }

  const handleReset = () => {
    setActiveStep(0)
  }

  const handleViewDetailsOpen = () => {
    setViewDetailsDialogOpen(true)
  }

  const handleViewDetailsClose = () => {
    setViewDetailsDialogOpen(false)
  }

  useEffect(() => {
    if (id && id.toLowerCase() !== 'undefined' && id.toLowerCase() !== 'new') {
      console.log(id)
      setIsGettingVehicle(true)
      controllers
        .getVehicleById(id)
        .then(response => {
          setVehicleDetails(response.value)
        })
        .finally(() => {
          setIsGettingVehicle(false)
        })
    }
  }, [id])

  useEffect(() => {
    if (vehicleGuid) {
      layout.setIsLayoutLoading(true)
      controllers
        .getNeedsClusterRemovedDetails(vehicleGuid)
        .then(response => {
          setInitialValues(response.value)
        })
        .finally(() => {
          layout.setIsLayoutLoading(false)
        })
    }
  })

  useEffect(() => {
    // if (vehicle.vehicleGuid) {
    //   setIsGettingPulledClusterPhotoInformation(true)
    //   controllers
    //     .getPulledClusterPhotoInformation(vehicle.vehicleGuid)
    //     .then(response => {
    //       setPulledClusterPhotoInformation(response.value)
    //     })
    //     .finally(() => {
    //       setIsGettingPulledClusterPhotoInformation(false)
    //     })
    // }
  }, [vehicle])

  // return (
  //   <>
  //     <PulledClusterPhotoAddEditDialog
  //       initialValues={pulledClusterPhotoInformation}
  //       isLoading={isSavingPulledClusterPhotoInformation}
  //       onClose={() => {
  //         setPulledClusterPhotoAddEditDialogOpen(false)
  //       }}
  //       onSave={values => {
  //         setIsSavingPulledClusterPhotoInformation(true)
  //         // controllers
  //         //   .updatePulledClusterPhotoInformation(vehicle.vehicleGuid!, values)
  //         //   .then(response => {
  //         //     enqueueSnackbar('Pulled Cluster Photo Saved Successfully!', { variant: 'success' })
  //         //     setPulledClusterPhotoInformation(response.value)
  //         //     setPulledClusterPhotoAddEditDialogOpen(false)
  //         //   })
  //         //   .finally(() => {
  //         //     setIsSavingPulledClusterPhotoInformation(false)
  //         //   })
  //       }}
  //       open={pulledClusterPhotoAddEditDialogOpen}
  //     />
  //     <Grid container spacing={1} alignItems='flex-start'>
  //       <Grid item xs={12}>
  //         <Card>
  //           <CardContent>
  //             <Grid container spacing={1} alignItems='flex-start'>
  //               <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
  //                 <Grid item xs={12} sm='auto' container alignItems='center' spacing={0}>
  //                   <Grid item>
  //                     <Typography fontWeight='bold' variant='h5' sx={{ pr: 1 }}>
  //                       Selected VIN:
  //                     </Typography>
  //                   </Grid>
  //                 </Grid>
  //                 <Grid item xs={12} sm='auto' container spacing={1}>
  //                   <Grid item>
  //                     <Button onClick={() => navigate('/to-do-list')} color='primary' startIcon={<ArrowBack />} variant='text'>
  //                       Back
  //                     </Button>
  //                   </Grid>

  //                   <Grid item sx={{ alignSelf: 'stretch' }}>
  //                     <Divider orientation='vertical' />
  //                   </Grid>

  //                   <Grid item>
  //                     <Button onClick={handleViewDetailsOpen} color='primary' endIcon={<ExpandMore />} variant='text'>
  //                       View Details
  //                     </Button>
  //                   </Grid>

  //                   {/* <Dialog open={viewDetailsDialogOpen} onClose={handleViewDetailsClose}>
  //                     <DialogContent>
  //                       <Grid container spacing={2} alignItems='center'>
  //                         <Grid item xs={12}>
  //                           <Typography variant='h6'>Vehicle Details</Typography>
  //                         </Grid>

  //                         <Grid item xs={12}>
  //                           <LabelField label='VIN:' value={vehicle.vin} />
  //                         </Grid>

  //                         <Grid item xs={12}>
  //                           <LabelField label='Buyer:' value={vehicle.buyer?.name} />
  //                         </Grid>

  //                         <Grid item xs={12}>
  //                           <LabelField label='Exporter:' value={vehicle.exporter?.name} />
  //                         </Grid>

  //                         <Grid item xs={12}>
  //                           <LabelField label='Year:' value={vehicle.year} />
  //                         </Grid>

  //                         <Grid item xs={12}>
  //                           <LabelField label='Make:' value={vehicle.make} />
  //                         </Grid>

  //                         <Grid item xs={12}>
  //                           <LabelField label='Model:' value={vehicle.model} />
  //                         </Grid>

  //                         <Grid item xs={12}>
  //                           <LabelField label='Importer Stock#:' value={vehicle.importerStockNumber} />
  //                         </Grid>
  //                       </Grid>
  //                     </DialogContent>
  //                   </Dialog> */}

  //                   <Dialog open={viewDetailsDialogOpen} onClose={handleViewDetailsClose} maxWidth='md'>
  //                     <DialogTitle>
  //                       Vehicle Details
  //                       <IconButton
  //                         aria-label='close'
  //                         onClick={handleViewDetailsClose}
  //                         sx={{
  //                           position: 'absolute',
  //                           right: 8,
  //                           top: 8,
  //                           color: theme => theme.palette.grey[500]
  //                         }}
  //                       >
  //                         <CloseIcon />
  //                       </IconButton>
  //                     </DialogTitle>
  //                     <DialogContent dividers>
  //                       <Grid container spacing={2}>
  //                         <Grid item xs={12}>
  //                           <LabelField label='VIN:' value={vehicle.vin} />
  //                         </Grid>
  //                         <Grid item xs={12}>
  //                           <LabelField label='Buyer:' value={vehicle.buyer?.name} />
  //                         </Grid>
  //                         <Grid item xs={12}>
  //                           <LabelField label='Exporter:' value={vehicle.exporter?.name} />
  //                         </Grid>
  //                         <Grid item xs={12}>
  //                           <LabelField label='Year:' value={vehicle.year} />
  //                         </Grid>
  //                         <Grid item xs={12}>
  //                           <LabelField label='Make:' value={vehicle.make} />
  //                         </Grid>
  //                         <Grid item xs={12}>
  //                           <LabelField label='Model:' value={vehicle.model} />
  //                         </Grid>
  //                         <Grid item xs={12}>
  //                           <LabelField label='Importer Stock#:' value={vehicle.importerStockNumber} />
  //                         </Grid>
  //                       </Grid>
  //                     </DialogContent>
  //                   </Dialog>
  //                 </Grid>
  //               </Grid>

  //               <Grid item xs={12}>
  //                 <Divider />
  //               </Grid>

  //               <Grid item xs={12} sm={3}>
  //                 <LabelField label='VIN:' value={vehicle.vin} />
  //               </Grid>

  //               <Grid item xs={12} sm={3}>
  //                 <LabelField label='Exporter/Buyer:' value={vehicle.exporter?.name} />
  //               </Grid>

  //               <Grid item xs={12} sm={3}>
  //                 <LabelField label='Year:' value={vehicle.year} />
  //               </Grid>

  //               <Grid item xs={12} sm={3}>
  //                 <LabelField label='Make:' value={vehicle.make} />
  //               </Grid>

  //               <Grid item xs={12} sm={3}>
  //                 <LabelField label='Model:' value={vehicle.model} />
  //               </Grid>

  //               <Grid item xs={12} sm={3}>
  //                 <LabelField label='Importer Stock#:' value={vehicle.importerStockNumber} />
  //               </Grid>
  //             </Grid>
  //           </CardContent>
  //         </Card>
  //       </Grid>

  //       <Grid item xs={12}>
  //         <Card>
  //           <CardContent>
  //             <Grid sx={{ width: '100%' }} spacing={4}>
  //               <Stepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
  //                 {steps.map((label, index) => {
  //                   const stepProps: { completed?: boolean } = {}

  //                   return (
  //                     <Step key={label} {...stepProps}>
  //                       <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
  //                     </Step>
  //                   )
  //                 })}
  //               </Stepper>

  //               {activeStep === steps.length ? (
  //                 <React.Fragment>
  //                   <Typography sx={{ mt: 2, mb: 1 }}>All steps completed - you&apos;re finished</Typography>
  //                   <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
  //                     <Box sx={{ flex: '1 1 auto' }} />
  //                     <Button onClick={handleReset}>Reset</Button>
  //                   </Box>
  //                 </React.Fragment>
  //               ) : (
  //                 <React.Fragment>
  //                   {activeStep === 0 && (
  //                     <Grid container spacing={2} marginTop={2}>
  //                       <Grid item xs={12}>
  //                         <Card variant='outlined'>
  //                           <CardContent>
  //                             <Grid container spacing={2} alignItems='center'>
  //                               <Grid item xs={12}>
  //                                 <TextField
  //                                   data-search
  //                                   InputProps={{
  //                                     endAdornment: (
  //                                       <InputAdornment position='end'>
  //                                         <SearchOutlined fontSize='small' />
  //                                       </InputAdornment>
  //                                     )
  //                                   }}
  //                                   label='Last 6 of VIN/Importer Stock#'
  //                                   name='search'
  //                                   onChange={e => setParameters({ ...parameters, search: e.target.value })}
  //                                   size='small'
  //                                   type='search'
  //                                   value={parameters.search}
  //                                 />
  //                               </Grid>
  //                               <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
  //                                 <Button variant='contained' sx={{ width: '10%' }}>
  //                                   SEARCH
  //                                 </Button>
  //                               </Grid>

  //                               <Grid item xs={12}>
  //                                 <LabelField label='VIN:' value={vehicle.vin} />
  //                               </Grid>

  //                               <Grid item xs={12}>
  //                                 <LabelField label='Year:' value={vehicle.year} />
  //                               </Grid>

  //                               <Grid item xs={12}>
  //                                 <LabelField label='Make:' value={vehicle.make} />
  //                               </Grid>

  //                               <Grid item xs={12}>
  //                                 <LabelField label='Model:' value={vehicle.model} />
  //                               </Grid>

  //                               <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
  //                                 <Button variant='contained' onClick={handleNext} sx={{ width: '20%' }}>
  //                                   START CLUSTER REMOVAL
  //                                 </Button>
  //                               </Grid>
  //                             </Grid>
  //                           </CardContent>
  //                         </Card>
  //                       </Grid>

  //                       <Grid item xs={12}>
  //                         <ExplanationAccordion variant='outlined'>
  //                           || Pressing “View Details” in the header will open an overlay with additional vehicle details. This
  //                           overlay can be closed by pressing the “X” button in the upper right corner. || Users will enter
  //                           (scan) the “Last 6 of VIN” or “Importer Stock#” into the input field on this screen and then press
  //                           “Search”. If the scanned/enter value matches either the “Last 6 of VIN” or “Importer Stock #” of the
  //                           selected vehicle, the VIN, Year, Make, and Model fields will be populated, and the “Start Cluster
  //                           Removal” button will be enabled. || Pressing “Start Cluster Removal” will save the name of the user
  //                           who pressed this button along with the date and time into the database and will advance the user to
  //                           the next step in the process. || The expected usage of this screen is that, because a user selected
  //                           a vehicle on the “Needs Cluster Removed” to do list, users on this screen are scanning one of the
  //                           barcodes on the “Convert Cluster” label which enters the “Last 6 of VIN” or “Importer Stock#” into
  //                           the input field on this screen, thus confirming that the user is in the correct vehicle. This
  //                           process helps enforce that users are in the vehicle at the time they are indicating that the cluster
  //                           removal process is beginning. ||
  //                         </ExplanationAccordion>
  //                       </Grid>
  //                     </Grid>
  //                   )}

  //                   {activeStep === 1 && (
  //                     <Grid container spacing={1} alignItems='flex-start' marginTop={2}>
  //                       <Grid item xs={12}>
  //                         {/* <Grid container spacing={2} alignItems='center' justifyContent='center'> */}
  //                         <Grid
  //                           item
  //                           xs={12}
  //                           sm={6}
  //                           onClick={() => {
  //                             setPulledClusterPhotoAddEditDialogOpen(true)
  //                           }}
  //                           sx={{
  //                             width: 480,
  //                             height: 320,
  //                             border: '2px solid',
  //                             borderColor: 'gray',
  //                             position: 'relative',
  //                             padding: 0,
  //                             display: 'flex',
  //                             justifyContent: 'center',
  //                             alignItems: 'center',
  //                             backgroundImage: process.env.PUBLIC_URL + '/1 Manufacturers Label.jpg',
  //                             backgroundSize: 'cover',
  //                             backgroundPosition: 'center',
  //                             boxSizing: 'border-box',
  //                             cursor: 'pointer'
  //                           }}
  //                         >
  //                           <Typography
  //                             variant='h5'
  //                             sx={{
  //                               position: 'absolute',
  //                               bottom: 0,
  //                               center: 0,
  //                               width: '100%',
  //                               backgroundColor: 'gray',
  //                               color: 'white',
  //                               textAlign: 'center',
  //                               fontWeight: 'bold'
  //                             }}
  //                           >
  //                             Pulled Cluster
  //                           </Typography>
  //                         </Grid>
  //                         {/* </Grid> */}
  //                       </Grid>
  //                       <Grid item xs={12}>
  //                         <ExplanationAccordion variant='outlined'>
  //                           || On the Needs Cluster Removed – Pulled Cluster Photo screen, the “Pulled Cluster” image cell is
  //                           empty by default and has a grey border to indicate no photo has been selected. Once a user has
  //                           uploaded an image, then a thumbnail of the useruploaded image will be displayed, and the image cell
  //                           border will be green. || Pressing on the image cell opens the “Needs Cluster Removed – Capture
  //                           Pulled Cluster Photo” screen. || Pressing “Next” will move the user to the “Needs Cluster Removed –
  //                           Pulled Cluster Review” screen. ||
  //                         </ExplanationAccordion>
  //                       </Grid>
  //                       <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
  //                         <Button variant='contained' onClick={handleNext} sx={{ width: '80%' }} endIcon={<ArrowRight />}>
  //                           Next
  //                         </Button>
  //                       </Grid>
  //                       <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
  //                         <Button variant='outlined' onClick={handleBack} sx={{ width: '80%' }} startIcon={<ArrowLeft />}>
  //                           Previous
  //                         </Button>
  //                       </Grid>
  //                     </Grid>
  //                   )}
  //                   {activeStep === 2 && (
  //                     <Grid container spacing={2} marginTop={2}>
  //                       <Grid item xs={12}>
  //                         <Card>
  //                           <CardHeader
  //                             title='Needs Cluster Removed'
  //                             titleTypographyProps={{
  //                               variant: 'h6',
  //                               style: { color: 'white' }
  //                             }}
  //                             sx={{ backgroundColor: '#2196F3', height: '30px' }}
  //                           />
  //                           <CardContent>
  //                             <Grid container>
  //                               <Grid item xs={12} container alignItems='center' spacing={1}>
  //                                 <Grid item>
  //                                   <CheckCircleIcon color='primary' />
  //                                 </Grid>

  //                                 <Grid item>
  //                                   <Typography>Pulled Cluster Photo</Typography>
  //                                 </Grid>
  //                               </Grid>

  //                               <Grid item xs={12}>
  //                                 <Divider />
  //                               </Grid>

  //                               <Grid item xs={12}>
  //                                 <LabelField label='Notes:' value={pulledClusterPhotoInformation.note} />
  //                               </Grid>
  //                             </Grid>
  //                           </CardContent>
  //                         </Card>
  //                       </Grid>

  //                       <Grid item xs={12} marginTop={2}>
  //                         <ExplanationAccordion variant='outlined'>
  //                           || If a “Pulled Cluster Photo” was uploaded on the "Needs Cluster Removed – Capture Pulled Cluster
  //                           Photo" screen, “Pulled Cluster Photo” will show a green checkmark and the “Submit” button will be
  //                           enabled. Any “Notes” entered in the Notes field on the "Needs Cluster Removed – Capture Pulled
  //                           Cluster Photo" screen will also be displayed. || Pressing “Submit” will upload the "Pulled Cluster
  //                           Photo" and associate it with the vehicle record along with the name of the user who completed the
  //                           process and a date/time stamp. Any “Notes” that were entered will appear under the “Vehicle Details
  //                           – Importer Notes (tab)”. || Pressing “Submit” will return the user to the “Needs Cluster Removed” to
  //                           do list screen.||
  //                         </ExplanationAccordion>
  //                       </Grid>

  //                       <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
  //                         <Button variant='contained' onClick={handleNext} sx={{ width: '90%' }} endIcon={<ArrowRight />}>
  //                           Submit
  //                         </Button>
  //                       </Grid>
  //                       <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
  //                         <Button variant='outlined' onClick={handleBack} sx={{ width: '90%' }} startIcon={<ArrowLeft />}>
  //                           Previous
  //                         </Button>
  //                       </Grid>
  //                     </Grid>
  //                   )}
  //                 </React.Fragment>
  //               )}
  //             </Grid>
  //           </CardContent>
  //         </Card>
  //       </Grid>
  //     </Grid>
  //   </>
  // )

  return (
    <Grid container spacing={1} alignItems='center'>
      <Grid item xs={12}>
        <NeedsClusterRemovedHeroCard vehicle={initialValues} />
      </Grid>

      {activeStep === 0 && (
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <NeedsClusterRemovedScanClusterBarcodeCard initialValues={initialValues} onNext={onNext} />
            </CardContent>
          </Card>
        </Grid>
      )}

      {activeStep === 1 && (
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <NeedsClusterRemovedPulledClusterPhotoCard initialValues={initialValues} onNext={onNext} onBack={handleBack} />
            </CardContent>
          </Card>
        </Grid>
      )}
    </Grid>
  )
}
